/* eslint-disable no-console */
import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import { Suspense } from 'react';

import { useMembersDataConfig } from './MembersDataGrid.config';

const MembersDataGrid = () => {
  const { config, data, loading } = useMembersDataConfig();

  return (
    <Suspense fallback={<LoadingScreen />}>
      <DataGrid config={config} data={data} loading={loading} />
    </Suspense>
  );
};

export default MembersDataGrid;
